const readMoreData = [
    {
        id: 1,
        title: "React JS",
        desc: "React is a free and open-source front-end JavaScript library for building user interfaces based on UI components. The main concept of ReactJS is virtual DOM and reusable UI components."
    },
    {
        id: 2,
        title: "Angular JS",
        desc: "AngularJS is a structural framework for dynamic web apps. It lets you use HTML as your template language and extend HTML's syntax to express your application's components clearly."
    },
    {
        id: 3,
        title: "Vue JS",
        desc: "VueJS is a progressive JavaScript framework for building interactive web interfaces. It focusses on the view layer & can be easily integrated into big projects for front-end development."
    },
]

export default readMoreData;